"use client";

import React from "react";
import * as Generated from "./components";

type StencilProps<C extends React.ElementType> = React.ComponentPropsWithRef<C>;

function withClassExtra<C extends React.ElementType>(Component: C) {
  const Wrapped = ({ className, ...props }: StencilProps<C>) =>
    React.createElement(Component as React.ElementType, {
      classExtra: className,
      ...props,
    });
  Wrapped.displayName =
    (Component as { displayName?: string }).displayName ?? String(Component);
  return Wrapped as unknown as C;
}

export const IsovAccordion = withClassExtra(Generated.IsovAccordion);
export const IsovAgendaItem = withClassExtra(Generated.IsovAgendaItem);
export const IsovAnimation = withClassExtra(Generated.IsovAnimation);
export const IsovAnnouncementBar = withClassExtra(
  Generated.IsovAnnouncementBar,
);
export const IsovAuthor = withClassExtra(Generated.IsovAuthor);
export const IsovAvatar = withClassExtra(Generated.IsovAvatar);
export const IsovBodyCta = withClassExtra(Generated.IsovBodyCta);
export const IsovBodySubscribe = withClassExtra(Generated.IsovBodySubscribe);
export const IsovButton = withClassExtra(Generated.IsovButton);
export const IsovCapture = withClassExtra(Generated.IsovCapture);
export const IsovCard = withClassExtra(Generated.IsovCard);
export const IsovCarousel = withClassExtra(Generated.IsovCarousel);
export const IsovCategory = withClassExtra(Generated.IsovCategory);
export const IsovCheckmark = withClassExtra(Generated.IsovCheckmark);
export const IsovContent = withClassExtra(Generated.IsovContent);
export const IsovContentItem = withClassExtra(Generated.IsovContentItem);
export const IsovContentSwitcher = withClassExtra(
  Generated.IsovContentSwitcher,
);
export const IsovDropdown = withClassExtra(Generated.IsovDropdown);
export const IsovFooter = withClassExtra(Generated.IsovFooter);
export const IsovForm = withClassExtra(Generated.IsovForm);
export const IsovHero = withClassExtra(Generated.IsovHero);
export const IsovIcon = withClassExtra(Generated.IsovIcon);
export const IsovInput = withClassExtra(Generated.IsovInput);
export const IsovLogo = withClassExtra(Generated.IsovLogo);
export const IsovLogoBar = withClassExtra(Generated.IsovLogoBar);
export const IsovMediaPlaceholder = withClassExtra(
  Generated.IsovMediaPlaceholder,
);
export const IsovNavGroup = withClassExtra(Generated.IsovNavGroup);
export const IsovNavItem = withClassExtra(Generated.IsovNavItem);
export const IsovPagination = withClassExtra(Generated.IsovPagination);
export const IsovPrimaryNavigation = withClassExtra(
  Generated.IsovPrimaryNavigation,
);
export const IsovProduct = withClassExtra(Generated.IsovProduct);
export const IsovQuote = withClassExtra(Generated.IsovQuote);
export const IsovRiverItem = withClassExtra(Generated.IsovRiverItem);
export const IsovRiverLayout = withClassExtra(Generated.IsovRiverLayout);
export const IsovSplitText = withClassExtra(Generated.IsovSplitText);
export const IsovTab = withClassExtra(Generated.IsovTab);
export const IsovTabSwitcher = withClassExtra(Generated.IsovTabSwitcher);
export const IsovTag = withClassExtra(Generated.IsovTag);
export const IsovTextStack = withClassExtra(Generated.IsovTextStack);
export const IsovTrigger = withClassExtra(Generated.IsovTrigger);

export type {
  IsovAccordionEvents,
  IsovAgendaItemEvents,
  IsovAnimationEvents,
  IsovAnnouncementBarEvents,
  IsovAuthorEvents,
  IsovAvatarEvents,
  IsovBodyCtaEvents,
  IsovBodySubscribeEvents,
  IsovButtonEvents,
  IsovCaptureEvents,
  IsovCardEvents,
  IsovCarouselEvents,
  IsovCategoryEvents,
  IsovCheckmarkEvents,
  IsovContentEvents,
  IsovContentItemEvents,
  IsovContentSwitcherEvents,
  IsovDropdownEvents,
  IsovFooterEvents,
  IsovFormEvents,
  IsovHeroEvents,
  IsovIconEvents,
  IsovInputEvents,
  IsovLogoEvents,
  IsovLogoBarEvents,
  IsovMediaPlaceholderEvents,
  IsovNavGroupEvents,
  IsovNavItemEvents,
  IsovPaginationEvents,
  IsovPrimaryNavigationEvents,
  IsovProductEvents,
  IsovQuoteEvents,
  IsovRiverItemEvents,
  IsovRiverLayoutEvents,
  IsovSplitTextEvents,
  IsovTabEvents,
  IsovTabSwitcherEvents,
  IsovTagEvents,
  IsovTextStackEvents,
  IsovTriggerEvents,
} from "./components";
